import { render, staticRenderFns } from "./templateAge.vue?vue&type=template&id=2d4d2ec0&scoped=true"
import script from "./templateAge.vue?vue&type=script&lang=js"
export * from "./templateAge.vue?vue&type=script&lang=js"
import style0 from "./templateAge.vue?vue&type=style&index=0&id=2d4d2ec0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d4d2ec0",
  null
  
)

export default component.exports